module.exports = __webpack_public_path__ + "static/img/AI合同审核.1839c82e.png";